
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import TableCell from '@material-ui/core/TableCell';
import { Co2service } from '../../services/bunkermaster/Co2service';
import { HfoCalculationService } from '../../services/bunkermaster/HfoCalculationService';
import { vlsfoCalculationService } from '../../services/bunkermaster/vlsfoCalculationService';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { toast } from 'react-toastify';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import EditIcon from '@mui/icons-material/Edit';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";

// import AddCardIcon from '@mui/icons-material/AddCard';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';


import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';



import Icon from '@material-ui/core/Icon';


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import Co2Calculatorvlsfomainengine from './Co2Calculatorvlsfomainengine';
import Co2Calculatorvlsfoauxiliaryengine from './Co2Calculatorvlsfoauxiliaryengine';
import Co2CalculatorMainengine from './Co2CalculatorMainengine';
import Co2CalculatorAuxiliaryengine from './Co2CalculatorAuxiliaryengine';
import MGOCalculation from './MGO';
import LNGCalculation from './LNG';
import CIIOverview from './CIIOverview';
import CIICalculator from './CIICalculator';
import { LeftSideMenu } from '../../shared';
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    text: {
        paddingLeft: 20
    },

    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    btn3: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        marginBottom: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 20px',
        width: 'auto !important'

        // width: '250px !important'
    },
    btn4: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 20px',
        width: 'auto !important',
        height: '45px',
        //     position: 'relative',
        //     left: '600px'
    },
    textstyles: {
        color: '#ff4717'
    },
    new: {
        top: "20px",
        color: '#fff '
    }
}));

function CoCalculation() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [order, setOrder] = React.useState({ ACR_mainengine: "", ACR_AE1: "", ACR_AE2: "", ACR_AE3: "", ExpectedFO_mainengine: "", ExpectedFO_AE1: "", ExpectedFO_AE2: "", ExpectedFO_AE3: "", Total_ActualFOconsumed: "", Total_ExpectedFO: "", CO2_Emissions_Actaul: "", CO2_Emissions_High_CV_fuel: "", Excess_CO2: "", });

    const [carbonFields, setCarbonFields] = React.useState({
        fueltype: "VLSFO",
        MCR_mainengine: "29400",
        Actualload_mainengine: "",
        MCR_AE1: "1200",
        Actualload_AE1: "",
        MCR_AE2: "1200",
        Actualload_AE2: "",
        MCR_AE3: "1200",
        Actualload_AE3: "",
        ActualFOconsumed_mainengine: "",
        ActualFOconsumed_AE1: "",
        ActualFOconsumed_AE2: "",
        ActualFOconsumed_AE3: "",
        FOcon_mainengine: "173.84",
        FOcon_AE1: "190",
        FOcon_AE2: "190",
        FOcon_AE3: "190",
        TotalMinutes: "",
        ActualCalorificValue: "",
        CvFromSeatrials: "",
        BDR_CV: "",
        CO2_Emissions_Actaul: "",
        CO2basedonAnnex_Vlsfo: "3.188",
        Cv_Seatrials: "42.7"
    })

    const [vlsfoshipDetails, setvlsfoShipDetails] = React.useState({
        sea_state: 1,
        load_condition: 1,
        MEPC: 3.188
    });
    const [shipDetails, setShipDetails] = React.useState({
        sea_state: 1,
        load_condition: 1,
        MEPC: 3.114
    });

    const [vlsfoSDmainengine, setvlsfoSDmainengine] = React.useState([]);
    const [vlsfoSDauxililaryengine, vlsfosetSDauxililaryengine] = React.useState([]);

    const [vlsfofields, setvlsfofields] = React.useState([]);
    const [vlsfofields2, vlsfosetFields2] = React.useState([]);
    const [vlsforesult, setvlsforesult] = React.useState({ Total_CO2_Emissions_Calculated: "", Total_CO2_Emissions_CV_from_Seatrials: "", Total_Clean_hull_conditons: "", Total_CO2_Emissions_from_BDN: "" })

    const [fields, setFields] = React.useState([]);
    const [SDmainengine, setSDmainengine] = React.useState([]);
    const [fields2, setFields2] = React.useState([]);
    const [SDauxililaryengine, setSDauxililaryengine] = React.useState([]);
    const [Hforesult, setHforesult] = React.useState({ totalgasflow: "", intermediate_co2_kg_h: "", intermediate_co2_kg_m: "", t_co2_fuel: "", Co2_kg_Total_duration: "", Co2_kg_Tonnes_duration: "", co2_kg_total: "" });

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const handleChange = (event, newValue) => {

        setValue(newValue);
    };
    const Co2calculation = () => {

        let result = Co2service.CalculateCo2(
            carbonFields
        )
        setOrder({ ...order, ...result });
    }
    const onFieldChange = (value, field) => {

        let local = carbonFields;
        local[field] = value;
        setCarbonFields({ ...carbonFields, ...local });
        /* let local = order;
        local[field] = value;
        setOrder({ ...order, ...local }) */
    }
    // const initialState ={
    //     Actualload_mainengine: "",
    //      Actualload_AE1: "" ,
    // }
    const vlsfoReset = () => {

        setOrder({ ...order, ...{ ACR_mainengine: "", ACR_AE1: "", ACR_AE2: "", ACR_AE3: "", ExpectedFO_mainengine: "", ExpectedFO_AE1: "", ExpectedFO_AE2: "", ExpectedFO_AE3: "", Total_ActualFOconsumed: "", Total_ExpectedFO: "", CO2_Emissions_Actaul: "", CO2_Emissions_High_CV_fuel: "", Excess_CO2: "" } })
        setCarbonFields({
            ...carbonFields, ...{
                Actualload_mainengine: "",
                Actualload_AE1: "",
                Actualload_AE2: "",
                Actualload_AE3: "",
                ActualFOconsumed_mainengine: "",
                ActualFOconsumed_AE1: "",
                ActualFOconsumed_AE2: "",
                ActualFOconsumed_AE3: "",
                TotalMinutes: ""

            }
        });

    }

    const onFieldChangeShipDetails = (value, field) => {

        let local = shipDetails;
        local[field] = value;
        setShipDetails({ ...shipDetails, ...local });
    }
    const HfoCalculation = () => {

        let result = HfoCalculationService.CalculateHfo(
            fields,
            fields2,
            shipDetails,
            SDmainengine,
            SDauxililaryengine
        )

        setFields([...result.mainengine]);
        setFields2([...result.axililaryengine]);
        setHforesult({ ...Hforesult, ...result });
    }

    const VlsfoReset = () => {
        //
        setvlsfofields([...[]])
        vlsfosetFields2([...[]])
        setvlsforesult({ ...vlsforesult, ...{ Total_Well_To_Wake_CO2_Emissions_Calculated: "", Total_CO2_Emissions_Calculated: "", Total_CO2_Emissions_CV_from_Seatrials: "", Total_Clean_hull_conditons: '', Total_CO2_Emissions_from_BDN: "" } })
    }
    const HfoReset = () => {
        setSDmainengine([...[]])
        setFields([...[]])
        setSDauxililaryengine([...[]])
        setFields2([...[]])
        setHforesult({ ...Hforesult, ...{ totalgasflow: "", intermediate_co2_kg_h: "", intermediate_co2_kg_m: "", t_co2_fuel: "", Co2_kg_Total_duration: "", Co2_kg_Tonnes_duration: "", co2_kg_total: "" } });
    }
    const vlsfoCalculation = () => {
        //
        let MainEngineFlagRaised = false;
        let AxililaryEngineFlagRaised = false;
        vlsfofields.map((row, idx) => {
            let index = idx + 1;
            if (row.mcr !== "" & row.fO_Con_100 !== "" && row.actual_load !== "" && row.start !== "" && row.end !== "" && row.mc_ctr_start !== "" && row.mc_ctr_end !== "" && row.Actual_Calorific_Value !== "" && row.BDN !== "") {
                MainEngineFlagRaised = true;
            } else {
                ToastError("Fill all Fields in Main Engine" + index + "Details");
                MainEngineFlagRaised = false;
                setvlsforesult({ ...vlsforesult, ...{ Total_Well_To_Wake_CO2_Emissions_Calculated: "", Total_CO2_Emissions_Calculated: "", Total_CO2_Emissions_CV_from_Seatrials: "", Total_Clean_hull_conditons: '', Total_CO2_Emissions_from_BDN: "" } })
            }
        })
        vlsfofields2.map((row, idx) => {
            let index = idx + 1;
            if (row.mcr !== "" & row.fO_Con_100 !== "" && row.actual_load !== "" && row.start !== "" && row.end !== "" && row.AE_FO_CTR_Start !== "" && row.AE_FO_CTR_End !== "") {
                AxililaryEngineFlagRaised = true;
            } else {
                ToastError("Fill all Fields in Axililary Engine" + index + "Details");
                AxililaryEngineFlagRaised = false;
                setvlsforesult({ ...vlsforesult, ...{ Total_Well_To_Wake_CO2_Emissions_Calculated: "", Total_CO2_Emissions_Calculated: "", Total_CO2_Emissions_CV_from_Seatrials: "", Total_Clean_hull_conditons: '', Total_CO2_Emissions_from_BDN: "" } })
            }
        })

        if (MainEngineFlagRaised == true || AxililaryEngineFlagRaised == true) {
            let result = vlsfoCalculationService.Calculatevlsfo(
                vlsfofields,
                vlsfofields2,
                // vlsfoshipDetails,
                // vlsfoSDmainengine,
                // vlsfoSDauxililaryengine
            )
            setvlsfofields([...result.mainengine]);
            vlsfosetFields2([...result.axililaryengine]);
            setvlsforesult({ ...vlsforesult, ...result });
        }
    }
    ///////////////////////////////////////////////////////////////////////////
    const vlsfoaddmainengine = () => {
        //
        let mainengine = {
            mcr: "",
            fO_Con_100: "",
            fuel_use: 1,
            actual_load: "",
            Actual_Load_MCR: "",
            start: "",
            end: "",
            total: "",
            mc_ctr_start: "",
            mc_ctr_end: "",
            me_fo_cons: "",
            Actual_Calorific_Value: "",
            Calorific_Value_from_Seatrails: "42.70",
            BDN: "",
            Well_To_Wake_co2_emission: "",
            co2_emission: "",
            co2_emission_seatrails: "",
            Clean_hull_conditons: "",
            co2_emission_BDN: ""
        };
        let vlsfomainengineupdatedesign = vlsfofields;
        if (vlsfofields.length <= 3) {
            vlsfomainengineupdatedesign.push(mainengine);
        }

        setvlsfofields([...vlsfomainengineupdatedesign]);

        // let shipdetailsmainengine = {
        //     MCR_KW: "",
        //     MCR_HP: "",
        //     FO_Con_100: "",

        // };
        // let hi = vlsfoSDmainengine;
        // if (vlsfoSDmainengine.length <= 3) {
        //     hi.push(shipdetailsmainengine);
        // }
        // setvlsfoSDmainengine([...hi]);
    }
    // const vlsfoshipdetailsmainenginedesign = () => {

    //     if (vlsfoSDmainengine.length !== 0) {
    //         return (

    //             <Box component="div">
    //                 <Grid container spacing={3}>
    //                     <Grid item xs={12} sm={12} md={12}>

    //                         <Box component="div" className="pr30">

    //                             <TableContainer component={Paper} c  >
    //                                 <Table aria-label="customized table">
    //                                     <TableHead>
    //                                         <TableRow>
    //                                             <StyledTableCell>Main Engine</StyledTableCell>
    //                                             <StyledTableCell >MCR (Kw)</StyledTableCell>
    //                                             <StyledTableCell >MCR (Hp)</StyledTableCell>
    //                                             <StyledTableCell >FO Con 100% MCR (g/kWh)</StyledTableCell>
    //                                             {/* <StyledTableCell >Exh Flow 100% MCR (kg/h)</StyledTableCell> */}
    //                                             {/* <StyledTableCell >Action</StyledTableCell> */}

    //                                         </TableRow>
    //                                     </TableHead>
    //                                     <TableBody>
    //                                         {vlsfoSDmainengine.map((row, idx) => (
    //                                             <StyledTableRow key={row.name}>
    //                                                 <StyledTableCell component="th" scope="row">
    //                                                     M/E {idx + 1}
    //                                                 </StyledTableCell>

    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonmainengine(e.target.value, "MCR_KW", idx)}
    //                                                         value={row.Fuel1}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonmainengine(e.target.value, "MCR_HP", idx)}
    //                                                         value={row.MCR_HP}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonmainengine(e.target.value, "FO_Con_100", idx)}
    //                                                         value={row.Target}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 {/* <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => onmainengine(e.target.value, "Exh_Flow_100", idx)}
    //                                                         value={row.Blend}
    //                                                     />
    //                                                 </StyledTableCell> */}
    //                                                 {/* <StyledTableCell  >

    //                                                     <EditIcon />
    //                                                 </StyledTableCell> */}
    //                                             </StyledTableRow>

    //                                         ))}
    //                                     </TableBody>
    //                                 </Table>
    //                             </TableContainer>
    //                         </Box>

    //                     </Grid>
    //                 </Grid>

    //             </Box>

    //         )
    //     }
    // }
    // const vlsfoonmainengine = (value, field, index) => {   //for calculate button
    //     //
    //     let local = vlsfoSDmainengine;
    //     let update = local[index];
    //     update[field] = value;
    //     local[index] = update;
    //     let result = vlsfoCalculationService.CalculateShipdetailsHfo(local);
    //     setvlsfoSDmainengine([...result]);
    //     //{shipdetailsmainenginedesign()}
    // }
    const vlsfoonmainenginehandleChange = (value, field, index) => {    // for onchange fields
        //
        let local = vlsfofields;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        setvlsfofields([...local]);

    }
    const vlsfomainenginedesign = () => {

        return (
            vlsfofields.map((row, idx) => {
                //if (idx <= 3) {
                return (
                    <>
                        <Accordion className="mainaccord" expanded="open">
                            <AccordionSummary

                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Main Engine {idx + 1} Details
                                    {/* <IconButton className="deleteicon" aria-label="delete">
                                        <DeleteIcon onClick={() =>
                                            mainengineremove(idx)
                                        } />
                                    </IconButton> */}
                                </Typography>

                            </AccordionSummary>

                            <AccordionDetails>
                                <Co2Calculatorvlsfomainengine
                                    onChange={vlsfoonmainenginehandleChange}
                                    idx={idx}
                                    data={row}
                                    vlsfovcalc={vlsfoCalculation}
                                />
                            </AccordionDetails>
                        </Accordion>

                    </>
                );

            })

        )
    }
    const vlsfoaddAxililaryengine = () => {

        let Axililaryengine = {
            mcr: "",
            fO_Con_100: "",
            fuel_use: 1,
            actual_load: "",
            start: "",
            end: "",
            total: "",
            AE_FO_CTR_Start: "",
            AE_FO_CTR_End: "",
            AE_Fo_consumption: "",
            Actual_Calorific_Value: "",
            Calorific_Value_from_Seatrails: "42.70",
            BDN: "",
            Well_To_Wake_co2_emission: "",
            co2_emission: "",
            co2_emission_seatrails: "",
            Clean_hull_conditons: "",
            co2_emission_BDN: ""
        };
        let axililaryengineupdatedesign = vlsfofields2;
        if (vlsfofields2.length <= 9) {
            axililaryengineupdatedesign.push(Axililaryengine);
        }
        vlsfosetFields2([...axililaryengineupdatedesign]);

        // let shipdetailsauxililaryengine = {
        //     MCR_KW: "",
        //     MCR_HP: "",
        //     FO_Con_100: "",

        // };
        // let hi = vlsfoSDauxililaryengine;
        // if (SDauxililaryengine.length <= 9) {
        //     hi.push(shipdetailsauxililaryengine);
        // }
        // vlsfosetSDauxililaryengine([...hi]);
    }
    // const vlsfoonaxililaryengine = (value, field, index) => {
    //     //
    //     let local = vlsfoSDauxililaryengine;
    //     let update = local[index];
    //     update[field] = value;
    //     local[index] = update;
    //     let result = vlsfoCalculationService.CalculateShipdetailsHfoAuxililaryengine(local);
    //     vlsfosetSDauxililaryengine([...result]);

    // }

    // const vlsfoshipdetailsaxiliaryengine = () => {
    //     if (vlsfoSDauxililaryengine.length !== 0) {
    //         return (

    //             <Box component="div">
    //                 <Grid container spacing={3}>
    //                     <Grid item xs={12} sm={12} md={12}>

    //                         <Box component="div" className="pr30">

    //                             <TableContainer component={Paper} c  >
    //                                 <Table aria-label="customized table">
    //                                     <TableHead>
    //                                         <TableRow>
    //                                             <StyledTableCell>Auxiliary Engine</StyledTableCell>
    //                                             <StyledTableCell >MCR (Kw)</StyledTableCell>
    //                                             <StyledTableCell >MCR (Hp)</StyledTableCell>
    //                                             <StyledTableCell >FO Con 100% MCR (g/kWh)</StyledTableCell>
    //                                             {/* <StyledTableCell >Exh Flow 100% MCR (kg/h)</StyledTableCell> */}
    //                                             {/* <StyledTableCell >Action</StyledTableCell> */}

    //                                         </TableRow>
    //                                     </TableHead>
    //                                     <TableBody>
    //                                         {vlsfoSDauxililaryengine.map((row, idx) => (

    //                                             <StyledTableRow key={row.name}>
    //                                                 <StyledTableCell component="th" scope="row">
    //                                                     A/E {idx + 1}
    //                                                 </StyledTableCell>

    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonaxililaryengine(e.target.value, "MCR_KW", idx)}
    //                                                         value={row.MCR_KW}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonaxililaryengine(e.target.value, "MCR_HP", idx)}
    //                                                         value={row.MCR_HP}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => vlsfoonaxililaryengine(e.target.value, "FO_Con_100", idx)}
    //                                                         value={row.Target}
    //                                                         type="number"
    //                                                     />
    //                                                 </StyledTableCell>
    //                                                 {/* <StyledTableCell  >
    //                                                     <BootstrapInput
    //                                                         onChange={(e) => onaxililaryengine(e.target.value, "Exh_Flow_100", idx)}
    //                                                         value={row.Blend}
    //                                                     />
    //                                                 </StyledTableCell> */}
    //                                                 {/* <StyledTableCell  >

    //                                                     <EditIcon />
    //                                                 </StyledTableCell> */}
    //                                             </StyledTableRow>

    //                                         ))}
    //                                     </TableBody>
    //                                 </Table>
    //                             </TableContainer>
    //                         </Box>

    //                     </Grid>
    //                 </Grid>

    //             </Box>

    //         )
    //     }
    // }
    const vlsfoonaxililaryenginehandleChange = (value, field, index) => {
        //
        let local = vlsfofields2;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        vlsfosetFields2([...local]);
    }
    const vlsfoaxililaryenginedesign = () => {
        return (
            vlsfofields2.map((row, idx) => {

                return (
                    <Accordion className="mainaccord" expanded="open">
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Auxiliary Engine {idx + 1} Details
                                {/* <IconButton className="deleteicon" aria-label="delete">
                                        <DeleteIcon onClick={() =>
                                            axililaryengineremove(idx)
                                        } />
                                    </IconButton> */}
                            </Typography>

                        </AccordionSummary>

                        <AccordionDetails>
                            <Co2Calculatorvlsfoauxiliaryengine
                                onChange={vlsfoonaxililaryenginehandleChange}
                                idx={idx}
                                data1={row}
                            />
                        </AccordionDetails>
                    </Accordion>

                )

            })
        )
    }
    const vlsfomainengineremove = (index) => {
        //
        let mainengine = vlsfofields.pop();
        //console.log(mainengine);
        setvlsfofields([...vlsfofields]);

        vlsfoSDmainengine.pop();
        setvlsfoSDmainengine([...SDmainengine]);
    }
    const vlsfoaxililaryengineremove = (index) => {
        //
        let axililaryengine = vlsfofields2.pop();
        //console.log(axililaryengine);
        vlsfosetFields2([...vlsfofields2]);

        vlsfoSDauxililaryengine.pop();
        vlsfosetSDauxililaryengine([...SDauxililaryengine]);
    }

    /////////////////////////////////////////////////////////////////////////////
    const addmainengine = () => {

        let mainengine = {
            ME_MCR: shipDetails.ME_MCR,
            ME_Exh_flow_100_MCR: shipDetails.ME_Exh_flow_100_MCR,
            start: "",
            end: "",
            total: "",
            mc_ctr_start: "",
            mc_ctr_end: "",
            me_fo_cons: "",
            sea_state: 1,
            load_condition: 1,
            co2: "",
            so2: "",
            me_load: "",
            me_load_unit: true,
            me_load_mcr: "",
            main_engine: ""
        };
        let mainengineupdatedesign = fields;
        if (fields.length <= 3) {
            mainengineupdatedesign.push(mainengine);
        }

        setFields([...mainengineupdatedesign]);

        let shipdetailsmainengine = {
            MCR_KW: "",
            MCR_HP: "",
            FO_Con_100: "",
            Exh_Flow_100: "",
        };
        let hi = SDmainengine;
        if (SDmainengine.length <= 3) {
            hi.push(shipdetailsmainengine);
        }
        setSDmainengine([...hi]);
    }
    const onmainengine = (value, field, index) => {   //for calculate button
        ;
        let local = SDmainengine;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        let result = HfoCalculationService.CalculateShipdetailsHfo(local);
        setSDmainengine([...result]);


        //{shipdetailsmainenginedesign()}


    }
    const onmainenginehandleChange = (value, field, index) => {    // for onchange fields
        //
        let local = fields;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        setFields([...local]);
    }
    const shipdetailsmainenginedesign = () => {

        if (SDmainengine.length !== 0) {
            return (

                <Box component="div">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>

                            <Box component="div" className="pr30">

                                <TableContainer component={Paper} c  >
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Main Engine</StyledTableCell>
                                                <StyledTableCell >MCR (Kw)</StyledTableCell>
                                                <StyledTableCell >MCR (Hp)</StyledTableCell>
                                                <StyledTableCell >FO Con 100% MCR (g/kWh)</StyledTableCell>
                                                <StyledTableCell >Exh Flow 100% MCR (kg/h)</StyledTableCell>
                                                {/* <StyledTableCell >Action</StyledTableCell> */}

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {SDmainengine.map((row, idx) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell component="th" scope="row">
                                                        M/E {idx + 1}
                                                    </StyledTableCell>

                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onmainengine(e.target.value, "MCR_KW", idx)}
                                                            value={row.Fuel1}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onmainengine(e.target.value, "MCR_HP", idx)}
                                                            value={row.MCR_HP}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onmainengine(e.target.value, "FO_Con_100", idx)}
                                                            value={row.Target}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onmainengine(e.target.value, "Exh_Flow_100", idx)}
                                                            value={row.Blend}
                                                        />
                                                    </StyledTableCell>
                                                    {/* <StyledTableCell  >

                                                        <EditIcon />
                                                    </StyledTableCell> */}
                                                </StyledTableRow>

                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>

                        </Grid>
                    </Grid>

                </Box>

            )
        }
    }

    const mainenginedesign = () => {

        return (
            fields.map((row, idx) => {
                //if (idx <= 3) {
                return (
                    <>
                        <Accordion className="mainaccord" expanded="open">
                            <AccordionSummary

                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Main Engine {idx + 1} Details
                                    {/* <IconButton className="deleteicon" aria-label="delete">
                                        <DeleteIcon onClick={() =>
                                            mainengineremove(idx)
                                        } />
                                    </IconButton> */}
                                </Typography>

                            </AccordionSummary>

                            <AccordionDetails>
                                <Co2CalculatorMainengine
                                    onChange={onmainenginehandleChange}
                                    idx={idx}
                                    data={row}
                                />
                            </AccordionDetails>
                        </Accordion>

                    </>
                );
                //}
                //    else{
                //     alert("Only four Main Engine !");
                //    }
            })

        )
    }
    const addAxililaryengine = () => {

        let Axililaryengine = {
            AE_MCR: shipDetails.AE_MCR,
            AE_Exh_flow_100_MCR: shipDetails.AE_Exh_flow_100_MCR,
            AE_FO_CTR_Start: "",
            AE_FO_CTR_End: "",
            AE_Fo_consumption: "",
            AE_Load1: "",
            AE_Load1_unit: true,
            AE_Load2: "",
            AE_Load_mcr: "",
            Axililary_engine: "",
            sea_state: 1,
            load_condition: 1,
        };
        let axililaryengineupdatedesign = fields2;
        if (fields2.length <= 9) {
            axililaryengineupdatedesign.push(Axililaryengine);
        }
        setFields2([...axililaryengineupdatedesign]);

        let shipdetailsauxililaryengine = {
            MCR_KW: "",
            MCR_HP: "",
            FO_Con_100: "",
            Exh_Flow_100: "",
        };
        let hi = SDauxililaryengine;
        if (SDauxililaryengine.length <= 9) {
            hi.push(shipdetailsauxililaryengine);
        }
        setSDauxililaryengine([...hi]);
    }
    const onaxililaryengine = (value, field, index) => {
        //
        let local = SDauxililaryengine;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        let result = HfoCalculationService.CalculateShipdetailsHfoAuxililaryengine(local);
        setSDauxililaryengine([...result]);

    }
    const onaxililaryenginehandleChange = (value, field, index) => {

        let local = fields2;
        let update = local[index];
        update[field] = value;
        local[index] = update;
        setFields2([...local]);
    }
    const shipdetailsaxiliaryengine = () => {
        if (SDauxililaryengine.length !== 0) {
            return (

                <Box component="div">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12}>

                            <Box component="div" className="pr30">

                                <TableContainer component={Paper} c  >
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Auxiliary Engine</StyledTableCell>
                                                <StyledTableCell >MCR (Kw)</StyledTableCell>
                                                <StyledTableCell >MCR (Hp)</StyledTableCell>
                                                <StyledTableCell >FO Con 100% MCR (g/kWh)</StyledTableCell>
                                                <StyledTableCell >Exh Flow 100% MCR (kg/h)</StyledTableCell>
                                                {/* <StyledTableCell >Action</StyledTableCell> */}

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {SDauxililaryengine.map((row, idx) => (

                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell component="th" scope="row">
                                                        A/E {idx + 1}
                                                    </StyledTableCell>

                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onaxililaryengine(e.target.value, "MCR_KW", idx)}
                                                            value={row.MCR_KW}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onaxililaryengine(e.target.value, "MCR_HP", idx)}
                                                            value={row.MCR_HP}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onaxililaryengine(e.target.value, "FO_Con_100", idx)}
                                                            value={row.Target}
                                                            type="number"
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell  >
                                                        <BootstrapInput
                                                            onChange={(e) => onaxililaryengine(e.target.value, "Exh_Flow_100", idx)}
                                                            value={row.Blend}
                                                        />
                                                    </StyledTableCell>
                                                    {/* <StyledTableCell  >

                                                        <EditIcon />
                                                    </StyledTableCell> */}
                                                </StyledTableRow>

                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>

                        </Grid>
                    </Grid>

                </Box>

            )
        }
    }
    const axililaryenginedesign = () => {
        return (
            fields2.map((row, idx) => {

                return (
                    <Accordion className="mainaccord" expanded="open">
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Auxiliary Engine {idx + 1} Details
                                {/* <IconButton className="deleteicon" aria-label="delete">
                                        <DeleteIcon onClick={() =>
                                            axililaryengineremove(idx)
                                        } />
                                    </IconButton> */}
                            </Typography>

                        </AccordionSummary>

                        <AccordionDetails>
                            <Co2CalculatorAuxiliaryengine
                                onChange={onaxililaryenginehandleChange}
                                idx={idx}
                                data1={row}
                            />
                        </AccordionDetails>
                    </Accordion>

                )

            })
        )
    }
    const mainengineremove = (index) => {

        let mainengine = fields.pop();
        //console.log(mainengine);
        setFields([...fields]);

        SDmainengine.pop();
        setSDmainengine([...SDmainengine]);
    }
    const axililaryengineremove = (index) => {

        let axililaryengine = fields2.pop();
        //console.log(axililaryengine);
        setFields2([...fields2]);

        SDauxililaryengine.pop();
        setSDauxililaryengine([...SDauxililaryengine]);
    }



    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>CO<sub>2</sub> Calculations</span>

                </div>
                <AppBar position="static" className="custom-tabs">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="VLSFO/OTHERS" {...a11yProps(0)} />
                        <Tab label="HFO (Scrubbers)" {...a11yProps(1)} />
                        {/* <Tab label="MGO" {...a11yProps(2)} /> 
                        <Tab label="LNG" {...a11yProps(3)} /> */}
                        {/* <Tab label="CII Calculator" {...a11yProps(2)} /> 
                        <Tab label="CII Overview" {...a11yProps(3)} /> */}
                    </Tabs>
                </AppBar>

                <TabPanel value={value} index={0} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk1">
                            <Button className={classes.new} onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">CO2 Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p className="subtitle">VLSFO Help Section</p><br />
                                        <p>This module performs the VLSFO Vessels related CO<sub>2</sub> calculations:</p>

                                        <img className="maxwidth100" src="/assets/images/VLSFO.jpg"></img><br /><br />
                                        <p>
                                            <li>Details of the Vessel and Voyage must be given.</li><br />
                                            <li>Sea State and Load Condition must be selected.</li><br />

                                            <li>Main Engine details can be provided by adding up to 4 Main Engines. Clicking on [Add Main Engine] button will</li>
                                            <div className={classes.text}> open new section where you can fill all the mandatory fields.</div><br />
                                            <li>Auxiliary Engine details can be provided by adding up to 10 Auxiliary Engines. Clicking on [Add Auxiliary Engine] button</li>
                                            <div className={classes.text}>will open new section where you can fill all the mandatory fields.</div><br />
                                            <li>Clicking on [Delete Main Engine] button will delete main engine section.</li><br />
                                            <li>Clicking on [Delete Auxiliary Engine] button will delete auxiliary engine section.</li><br />
                                            <li>Clicking on Reset button will reset the page.</li><br />
                                        </p>

                                        <p className="subtitle">Main Engine calculation section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/VLSFO-1.jpg"></img><br /><br />
                                        <p>
                                            <li> Well to wake calculation (M/E FO consumption * Fuel in use) Internally we will take calculation values.</li><br />
                                            <li>Tank to wake calculation (M/E FO consumption * Fuel in use) Internally we will take calculation values.</li><br />
                                            <li>Using a higher CV fuel & Clean hull (t) calculation: ((M/E FO consumption - Estimated FO consumption</li>
                                            <div className={classes.text}>based on CV 42.70 (t) ) * Fuel in use).</div><br />
                                            <li>Clean hull conditions (t) calculation: ((M/E FO consumption - Estimated FO consumption based fuel</li>
                                            <div className={classes.text}>in use -CV 40.10 (t) ) * Fuel in use).</div><br />
                                            <li>Difference in CV from BDN  calculation: ((M/E FO consumption - Estimated FO consumption due to higher \</li>
                                            <div className={classes.text}>BDN CV (D13-CV 41.10) (t) ) * Fuel in use).</div>
                                        </p>


                                        <p></p>
                                        <p className="subtitle">Auxiliary Engine Calculation section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/VLSFO-2.jpg"></img><br /><br/>
                                        <p >
                                            <li>Well to wake calculation (A/E FO consumption * Fuel in use)  Internally we will take calculation values.</li><br />
                                            <li>Tank to wake calculation (A/E FO consumption * Fuel in use)  Internally we will take calculation values.</li><br />
                                            <li>Using a higher CV fuel & Clean hull (t) calculation: ((A/E FO consumption - Estimated FO consumption based</li>
                                            <div className={classes.text}>on CV 42.70 (t) ) * Fuel in use).</div><br />
                                            <li>Clean hull conditions (t) calculation: ((A/E FO consumption - Estimated FO consumption based fuel</li>
                                            <div className={classes.text}>in use -CV 40.10 (t) ) * Fuel in use).</div><br />
                                            <li>Difference in CV from BDN  calculation: ((A/E FO consumption - Estimated FO consumption due to higher \</li>
                                            <div className={classes.text}>BDN CV (D13-CV 41.10) (t) ) * Fuel in use).</div></p>

                                        <p className="subtitle">Result section:</p><br />

                                        <img className="maxwidth100" src="/assets/images/VLSFO-3.jpg"></img><br/><br/>
                                        <p> <li>Total Well-to-Wake CO<sub>2</sub> Emissions-Calculations: (Main Engine Well to wake result + Auxiliary Engine well to Wake result).</li><br />
                                            <li>Total Tank-to-Wake CO<sub>2</sub> Emissions-Calculations: (Main Engine Tank to wake result + Auxiliary Engine tank to Wake result).</li><br />
                                            <h6>Total CO<sub>2</sub> Emission Calculation:</h6><br />
                                            <li>Using a higher CV fuel & Clean hull (t):
                                                ((Using a higher CV fuel & Clean hull (t) + Using a higher CV fuel & Clean hull (t))</li>
                                            <div className={classes.text}>/Total Well-to-Wake CO<sub>2</sub> Emissions result).</div><br />
                                            <li>Clean hull conditions (t):
                                                ((Clean hull conditions (t) + Clean hull conditions (t))/Total Well-to-Wake CO<sub>2</sub> Emissions result).</li><br />
                                            <li>Difference in CV from BDN :
                                                ((Difference in CV from BDN + Difference in CV from BDN)/ Total Well-to-Wake CO<sub>2</sub> Emissions result).</li></p>

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>

                    <Accordion className="mainaccord" expanded={true}>
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Ship Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails open>
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={12} md={4} lg={3} >
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >Ship Name  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput

                                                        />   </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label > IMO </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput type="number" />   </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >  Sample No.. </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput />   </Paper>
                                                    </Grid>

                                                </Grid>


                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4} lg={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >Voyage Start </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput type="date" />

                                                        </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label > Start Port Name </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput />  &nbsp;           &nbsp;

                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >Sea State  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}>
                                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                                // onChange={(e) => oninputChange(e.target.value, "sea_state")}
                                                                value={shipDetails.sea_state}
                                                            >
                                                                <MenuItem value={1}>Calm</MenuItem>
                                                                <MenuItem value={2}>Smooth</MenuItem>
                                                                <MenuItem value={3}>Slight</MenuItem>
                                                            </Select>
                                                        </Paper>

                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >Voyage End  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" type="date"
                                                        //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />   </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >End Port Name </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}><BootstrapInput
                                                        //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />  &nbsp;       &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={6} md={5}>
                                                        <Paper className={classes.paper}>  <label >Load Condition  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={6} md={7} className="inputouterc">
                                                        <Paper className={classes.paper}>
                                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                                //onChange={(e) => oninputChange(e.target.value, "load_condition ")}
                                                                value={shipDetails.load_condition}
                                                            >
                                                                <MenuItem value={1}>Loaded</MenuItem>
                                                                <MenuItem value={2}>Ballast</MenuItem>
                                                                <MenuItem value={3}>Part Loaded</MenuItem>
                                                            </Select>
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} className="pos_relative">
                                            <Paper className={classes.paper}>

                                                <Box
                                                    className="pos_relative_img shipimg"
                                                    component="img"
                                                    display="block"
                                                    height="100%"
                                                    width="auto"
                                                    align="right"

                                                    src={
                                                        process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                                                        "assets/images/CO2-ship.jpg"
                                                    }
                                                />


                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    {/* {vlsfoshipdetailsmainenginedesign()} */}

                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={12} md={12}>

                                            <button type="button" className={classes.btn3} onClick={vlsfoaddmainengine}  > <AddCircleOutlineIcon /> Add Main Engine</button>{''}
                                            <button type="button" className={classes.btn3} onClick={vlsfomainengineremove}  > <DoNotDisturbOnIcon /> Delete Main Engine</button>{''}
                                            {/* {vlsfoshipdetailsaxiliaryengine()} */}
                                            <button type="button" className={classes.btn3} onClick={vlsfoaddAxililaryengine} ><AddCircleOutlineIcon />Add Auxiliary Engine</button>{''}
                                            <button type="button" className={classes.btn3} onClick={vlsfoaxililaryengineremove}  > <DoNotDisturbOnIcon /> Delete Auxiliary Engine</button>{''}
                                            <button type="reset" className={classes.btn4} onClick={VlsfoReset} >Reset</button>{''}
                                            <button type="reset" className={classes.btn4} onClick={vlsfoCalculation} >Calculate</button>{''}

                                        </Grid>
                                    </Grid>

                                </div>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>


                    {vlsfomainenginedesign()}

                    {vlsfoaxililaryenginedesign()}

                    <Accordion className="mainaccord" expanded={true}>
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Results</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={12} lg={4} className="co2_res2">
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} sm={12} md={6} >
                                                        <Paper className={classes.paper}>  <label style={{ fontWeight: "bold" }}>Total Well-to-Wake CO<sub>2</sub> Emissions-Calculated</label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={6}  >
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" value={vlsforesult.Total_Well_To_Wake_CO2_Emissions_Calculated === "NaN" ? "" : vlsforesult.Total_Well_To_Wake_CO2_Emissions_Calculated} />
                                                            &nbsp;  Tonnes    &nbsp;
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}>  <label style={{ fontWeight: "bold" }}>Total Tank-to-Wake CO<sub>2</sub>Emissions-Calculated</label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" value={vlsforesult.Total_CO2_Emissions_Calculated === "NaN" ? "" : vlsforesult.Total_CO2_Emissions_Calculated} />
                                                            &nbsp;  Tonnes    &nbsp;
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}>  <label style={{ fontWeight: "bold" }}>Total CO<sub>2</sub> Emission Calculated : </label></Paper>
                                                    </Grid>
                                                </Grid>
                                                <br></br>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}>  <label >Using a higher CV fuel & Clean hull (t)</label></Paper>
                                                    </Grid>



                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" value={vlsforesult.Total_CO2_Emissions_CV_from_Seatrials === "NaN" ? "" : vlsforesult.Total_CO2_Emissions_CV_from_Seatrials} />
                                                            &nbsp;  %    &nbsp;
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}>  <label >Clean hull conditons (t)</label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" value={vlsforesult.Total_Clean_hull_conditons === "NaN" ? "" : vlsforesult.Total_Clean_hull_conditons} />
                                                            &nbsp;  %    &nbsp;
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}>  <label >Difference in CV from BDN </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={6}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" value={vlsforesult.Total_CO2_Emissions_from_BDN === "NaN" ? "" : vlsforesult.Total_CO2_Emissions_from_BDN} />
                                                            &nbsp;  %    &nbsp;
                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                        </Grid>



                                        <Grid item xs={12} md={12} lg={4} className="co2_res2">

                                            <Box component="div" className="resultbox">
                                                <p>Average Calorific value, 2021 from VPS database</p>
                                                <Box component="div" className="bunkarinput wid180  mar25">

                                                    <form className={classes.root} noValidate autoComplete="off">

                                                        <Box component="div" className="afcv">
                                                            <label className=" width120">HFO   </label>

                                                            <BootstrapInput value={"40.14"} readOnly className="smallbox1 " />  &nbsp;     kJ/g
                                                        </Box>
                                                        <Box component="div" className="afcv">
                                                            <label className="  ">ULSFO   </label>
                                                            <BootstrapInput value={"42.46"} readOnly className="smallbox1" />   &nbsp;   kJ/g

                                                        </Box>
                                                        <Box component="div" className="afcv">
                                                            <label className=" ">Distillate Fuel (MGO)   </label>

                                                            <BootstrapInput value={"42.68"} readOnly className="smallbox1" />  &nbsp;    kJ/g

                                                        </Box>
                                                        <Box component="div" className="afcv">
                                                            <label className=" ">VLSFO  </label>

                                                            <BootstrapInput value={"41.68"} readOnly className="smallbox1" />  &nbsp;   kJ/g

                                                        </Box>
                                                    </form>
                                                </Box>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} md={12} lg={4} className="co2_res2">

                                            <Box component="div" className="resultbox">
                                                <p>CO<sub>2</sub> Emission Factor in t CO2/t fuel.</p>
                                                <Box component="div" className="bunkarinput mar25">

                                                    <form className={classes.root} noValidate autoComplete="off">
                                                        <Box component="div" className="co2third">
                                                            <label className=" ">Fuel Type   </label>
                                                            <label className=" ">Well-To_Wake   </label>
                                                            <label className=" ">Tank-To-Wake   </label>
                                                        </Box>
                                                        <Box component="div" className="co2third">
                                                            <label className=" ">HFO   </label>
                                                            <BootstrapInput value={"3.545"} readOnly className="" />
                                                            <BootstrapInput value={"3.114"} readOnly className="" />
                                                        </Box>

                                                        <Box component="div" className="co2third">
                                                            <label className="  ">VLSFO   </label>
                                                            <BootstrapInput value={"3.734"} readOnly className="" />
                                                            <BootstrapInput value={"3.118"} readOnly className="" />
                                                        </Box>
                                                        <Box component="div" className="co2third">
                                                            <label className=" ">MGO   </label>

                                                            <BootstrapInput value={"3.782"} readOnly className="" />
                                                            <BootstrapInput value={"3.206"} readOnly className="" />
                                                        </Box>
                                                        <Box component="div" className="co2third">
                                                            <label className="">LNG  </label>

                                                            <BootstrapInput value={"3.28"} readOnly className="" />
                                                            <BootstrapInput value={"2.75"} readOnly className="" />
                                                        </Box>
                                                    </form>
                                                </Box>
                                            </Box>
                                        </Grid>



                                    </Grid>
                                </div>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                </TabPanel>

                <TabPanel value={value} index={1} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk1">
                            <Button className={classes.new} onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">CO2 Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p className="subtitle">HFO(Scrubbers) Help Section </p><br />
                                        <p>This module performs the HFO(Scrubbers) Vessels related CO<sub>2</sub> calculations:</p>

                                        <img className="maxwidth100" src="/assets/images/HFO1.jpg"></img><br /><br />

                                        <p>
                                            <li> Details of the Vessel and Voyage must be given.</li>
                                            <br></br>
                                            <li>Sea state and Load Condition must be selected.</li>  <br></br>
                                            <li>Main Engine details can be provided by adding up to 4 Main Engines. Clicking on [Add Main Engine] button will open</li>
                                            <div className={classes.text}> two new sections where you can fill all the mandatory fields.</div>  <br></br>
                                            <li>Auxiliary Engine details can be provided by adding up to 10 Auxiliary Engines. Clicking on [Add Auxiliary Engine] button will open</li>
                                            <div className={classes.text}> two new sections where you can fill all the mandatory fields.</div>  <br />
                                            <li>Clicking on [Delete Main Engine] button will delete main engine section.</li><br />
                                            <li>Clicking on [Delete Auxiliary Engine] button will delete auxiliary engine section.</li><br />
                                            <li>Clicking on Reset button will reset the page.</li>
                                        </p>

                                        <p className="subtitle">Main Engine Calculation section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/HFO2.jpg"></img><br/><br />
                                        <p>
                                            <li>Clicking on Add Main Engine section will open ship details section in that section adding</li>
                                            <div className={classes.text}> MCR(kw) will automatically convert to MCR(HP).</div><br />
                                            <li>Total calculation : (End time - Start time).</li><br />
                                            <li>M/E FO consumption calculation : (M/E CTR End - M/E CTR Start)</li><br />
                                            <li>M/E Load % MCR: for HP default value set to(0.44) and for KW default value set to (0.59)</li>
                                            <div className={classes.text}> using these calculation values will differ.</div><br />
                                            <li>Main Engine 1 Gas Flow calculation : (Exh flow 100% MCR(kg/h)) * M/E Load % MCR (Default value(0.44)).</li>
                                        </p><br />
                                        <p className="subtitle">Auxiliary Engine Calculation section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/HFO3.jpg"></img><br /><br />
                                        <p>
                                            <li>Clicking on Add Auxiliary Engine section will open ship details in that section adding</li>
                                            <div className={classes.text}>MCR(kw) automatically convert to MCR(HP).</div><br />
                                            <li>A/E FO Consumption calculation : A/E FO CTR End - A/E FO CTR Start.</li><br />
                                            <li>Auxiliary Engine 1 Gas Flow : Exh Flow 100% MCR (kg/h) * A/E Load % MCR.</li><br />

                                        </p>

                                        <p className="subtitle">Intermediate Results section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/HFO4.jpg"></img><br /><br />
                                        <p>
                                            <li>Total Gas Flow Calculation : Main Engine 1 Gas Flow + Auxiliary Engine 1 Gas Flow.</li><br />
                                            <li>CO<sub>2</sub> Calculation : Total Gas Flow * Onboard measured CO2 (Main Engine).</li><br />
                                            <li>t-CO<sub>2</sub>/t-Fuel calculation : ( CO<sub>2</sub> Tones for the duration / (M/E FO Consumption + A/E FO Consumption)).</li><br />
                                        </p>

                                        <p className="subtitle">Results section: </p><br />
                                        <img className="maxwidth100" src="/assets/images/HFO5.jpg"></img><br /><br />
                                        <p>
                                            <li>Exh Flow :  Result of Total Gas Flow.</li><br />
                                            <li>CO<sub>2</sub> : Result of CO<sub>2</sub>.</li><br />
                                            <li>Measured CO<sub>2</sub> (For the Duration) : CO<sub>2</sub>/1000.</li><br />
                                            <li>Calculated CO<sub>2</sub> : ((M/E FO Consumption + A/E FO Consumption) * MEPC(3.114)).</li>
                                        </p>
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>

                    <Accordion className="mainaccord" expanded={true}>
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Ship Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails open>
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >Ship Name  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput className="width200"

                                                        />   </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label > IMO </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput className="width200" type="number" />   </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >  Sample No.. </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput className="width200" />   </Paper>
                                                    </Grid>

                                                </Grid>


                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >Voyage Start </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" type="date" />

                                                        </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label > Start Port Name </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput />  &nbsp;           &nbsp;

                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                                {/* <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >Sea State  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}>
                                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                                // onChange={(e) => oninputChange(e.target.value, "sea_state")}
                                                                value={shipDetails.sea_state}
                                                            >
                                                                <MenuItem value={1}>Calm</MenuItem>
                                                                <MenuItem value={2}>Smooth</MenuItem>
                                                                <MenuItem value={3}>Slight</MenuItem>
                                                            </Select>
                                                        </Paper>

                                                    </Grid>

                                                </Grid> */}
                                                {/* <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >M/E MCR  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput
                                                            onChange={(e) => onFieldChangeShipDetails(e.target.value, "ME_MCR")}
                                                        />  &nbsp;    kW   &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >M/E FO Con 100% MCR </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput />  &nbsp;    g/kWh   &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >A/E MCR </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput
                                                            onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_MCR")}
                                                        />  &nbsp; kW   &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >A/E FO Con 100% MCR  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput />  &nbsp;       kW    &nbsp;

                                                        </Paper>
                                                    </Grid>

                                                </Grid> */}



                                            </Paper>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >Voyage End  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput className="c_datewidth" type="date"
                                                        //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />   </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >End Port Name </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput
                                                        //onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />  &nbsp;       &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>
                                                {/* <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >Load Condition  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}>
                                                            <Select labelId="outlined-label5" className="mr20 bunkerselect  "
                                                                //onChange={(e) => oninputChange(e.target.value, "load_condition ")}
                                                                value={shipDetails.load_condition}
                                                            >
                                                                <MenuItem value={1}>Loaded</MenuItem>
                                                                <MenuItem value={2}>Ballast</MenuItem>
                                                                <MenuItem value={3}>Part Loaded</MenuItem>
                                                            </Select>
                                                        </Paper>
                                                    </Grid>

                                                </Grid> */}
                                                {/* <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <BootstrapInput />  <label > hp </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput />  &nbsp; kW &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >M/E Exh flow 100% MCR </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}>
                                                            <BootstrapInput
                                                                onChange={(e) => onFieldChangeShipDetails(e.target.value, "ME_Exh_flow_100_MCR")}
                                                            />  &nbsp; kg/h &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >A/E Exh flow 100% MCR  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput
                                                            onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />  &nbsp;     kg/h   &nbsp; </Paper>
                                                    </Grid>

                                                </Grid> */}
                                                {/* <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >A/E Exh flow 100% MCR  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput
                                                        // onChange={(e) => onFieldChangeShipDetails(e.target.value, "AE_Exh_flow_100_MCR")}
                                                        />  &nbsp;     kg/h   &nbsp; </Paper>
                                                    </Grid>

                                                </Grid> */}





                                            </Paper>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={2} className="pos_relative">
                                            <Paper className={classes.paper}>

                                                <Box
                                                    className="pos_relative_img shipimg"
                                                    component="img"
                                                    display="block"
                                                    height="100%"
                                                    width="auto"
                                                    align="right"

                                                    src={
                                                        process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                                                        "assets/images/CO2-ship.jpg"
                                                    }
                                                />


                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    {shipdetailsmainenginedesign()}
                                    {shipdetailsaxiliaryengine()}
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={12} md={12}>

                                            <button type="button" className={classes.btn3} onClick={addmainengine}  > <AddCircleOutlineIcon /> Add Main Engine</button>{''}
                                            <button type="button" className={classes.btn3} onClick={mainengineremove}  > <DoNotDisturbOnIcon /> Delete Main Engine</button>{''}


                                            <button type="button" className={classes.btn3} onClick={addAxililaryengine} ><AddCircleOutlineIcon />Add Auxiliary Engine</button>{''}
                                            <button type="button" className={classes.btn3} onClick={axililaryengineremove}  > <DoNotDisturbOnIcon /> Delete Auxiliary Engine</button>{''}
                                            <button type="reset" className={classes.btn4} onClick={HfoReset} >Reset</button>{''}
                                            <button type="reset" className={classes.btn4} onClick={HfoCalculation} >Calculate</button>{''}

                                        </Grid>
                                    </Grid>

                                </div>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>


                    {mainenginedesign()}

                    {axililaryenginedesign()}


                    <Accordion className="mainaccord" expanded={true}>
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Intermediate Results</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                    </Grid>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label > Total Gas Flow  </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput value={Hforesult.totalgasflow === "NaN" ? "" : Hforesult.totalgasflow} className="disabled" disabled />  &nbsp; kg/h &nbsp;</Paper>
                                                    </Grid>

                                                </Grid>

                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >t-CO<sub>2</sub>/t-Fuel</label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput value={Hforesult.t_co2_fuel === "NaN" ? "" : Hforesult.t_co2_fuel} className="disabled" disabled /> &nbsp;  &nbsp;

                                                        </Paper>
                                                    </Grid>

                                                </Grid>
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >CO<sub>2</sub> </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput value={Hforesult.intermediate_co2_kg_h === "NaN" ? "" : Hforesult.intermediate_co2_kg_h} className="disabled" disabled />  &nbsp; kg/h &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >MEPC 66-21 </label></Paper>
                                                    </Grid>


                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput value={shipDetails.MEPC} className="disabled" />  &nbsp; t-CO<sub>2</sub>/t-Fuel &nbsp; </Paper>
                                                    </Grid>


                                                </Grid>

                                            </Paper>
                                        </Grid>

                                        {/* <Grid item xs={12} sm={6} md={3}>
                                            <Paper className={classes.paper}>
                                                <Grid container spacing={1}>

                                                    <Grid item xs={12} md={5}>
                                                        <Paper className={classes.paper}>  <label >CO<sub>2</sub> </label></Paper>
                                                    </Grid>

                                                    <Grid item xs={12} md={7}>
                                                        <Paper className={classes.paper}><BootstrapInput value={Hforesult.intermediate_co2_kg_m === "NaN" ? "" : Hforesult.intermediate_co2_kg_m} className="disabled" disabled />  &nbsp; kg/m &nbsp; </Paper>
                                                    </Grid>

                                                </Grid>

                                            </Paper>
                                        </Grid> */}

                                    </Grid>
                                </div>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion className="mainaccord" expanded={true}>
                        <AccordionSummary

                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <Typography>Results</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl + " fullwidth"}>
                                <div className={classes.root}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={2}>

                                            <Paper className={classes.paper}>  <h3>Exh Flow</h3></Paper>

                                            <Paper className={classes.paper}> <h1> {Hforesult.totalgasflow === "NaN" ? "" : Hforesult.totalgasflow} </h1> <span>kg/h  </span> </Paper>

                                        </Grid>

                                        <Grid item xs={12} sm={6} md={2}>

                                            <Paper className={classes.paper}>  <h3>CO<sub>2</sub></h3></Paper>

                                            <Paper className={classes.paper}> <h1> {Hforesult.intermediate_co2_kg_h === "NaN" ? "" : Hforesult.intermediate_co2_kg_h}  </h1><span>kg/h  </span>  </Paper>

                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>

                                            <Paper className={classes.paper}>  <h3>CO<sub>2</sub></h3></Paper>

                                            <Paper className={classes.paper}> <h1> {Hforesult.Co2_kg_Total_duration === "NaN" ? "" : Hforesult.Co2_kg_Total_duration} </h1> <span>kg </span> </Paper>
                                            <span>Total for the duration</span>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={2}>

                                            <Paper className={classes.paper}>  <h3>Measured CO<sub>2</sub></h3></Paper>

                                            <Paper className={classes.paper}> <h1> {Hforesult.Co2_kg_Tonnes_duration === "NaN" ? "" : Hforesult.Co2_kg_Tonnes_duration} Tonnes </h1> <span>For the Duration</span>  </Paper>

                                        </Grid>


                                        <Grid item xs={12} sm={6} md={2}>

                                            <Paper className={classes.paper}>  <h3>Calculated CO<sub>2</sub></h3></Paper>

                                            <Paper className={classes.paper}> <h1>{Hforesult.co2_kg_total === "NaN" ? "" : Hforesult.co2_kg_total} Tonnes</h1> <span>(3.114t-CO<sub>2</sub>/f-fuel-HFO)</span>  </Paper>

                                        </Grid>

                                    </Grid>
                                </div>
                            </FormControl>
                        </AccordionDetails>
                    </Accordion>
                </TabPanel>
                {/* 
                <TabPanel value={value} className="custom-tab-section">
                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk1">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">CO2 Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>This module performs the CO2 Calculations related calculations:</p>

                                        <p className="subtitle">Example 1 - Calculation of MGO </p>
                                        <img className="maxwidth100" src="/assets/images/MGO.jpg"></img>
                                        <br></br> <br></br>
                                        <p className="subtitle">Example 2 - Calculation of MGO </p>
                                        <img className="maxwidth100" src="/assets/images/MGO-1.jpg"></img>


                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>
                    <MGOCalculation />
                </TabPanel>
                <TabPanel value={value}  className="custom-tab-section">
                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk1">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">CO2 Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>This module performs the CO2 Calculations related calculations:</p>

                                        <p className="subtitle">Example 1 - Calculation of LNG </p>
                                        <img className="maxwidth100" src="/assets/images/LNG.jpg"></img>
                                        <br></br> <br></br>
                                        <p className="subtitle">Example 2 - Calculation of LNG </p>
                                        <img className="maxwidth100" src="/assets/images/LNG-1.jpg"></img>


                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>
                    <LNGCalculation />
                </TabPanel> */}


            </div>
        </div>
    );
}
export default CoCalculation;